var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTomatoColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17.2 17.2",
    style: {
      enableBackground: "new 0 0 17.2 17.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B31F24;}\n\t.st1{fill:#0C8B44;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.9,2.8l-0.3,0.1c-0.5,0.2-0.8,0.5-1,0.8c0.2,0.1,0.5,0.2,0.7,0.4c0.5,0.4,0.8,0.8,1,1.4l0.4,0.8l-0.9-0.1 c-0.6-0.1-1.1,0.1-1.5,0.2c-0.2,0.1-0.3,0.1-0.5,0.2c0,0.1,0,0.2,0,0.2c0,0.5,0,0.9-0.2,1.4c-0.2,0.6-0.5,1-0.9,1.4L9.3,9.8L9,9.6 C8.5,9.3,8.1,8.9,7.8,8.4C7.6,8,7.5,7.6,7.4,7.2c-0.2,0-0.4,0-0.6,0.1c-0.4,0-0.9,0-1.5,0.3L4.5,8l0.1-0.9c0-0.6,0.2-1.1,0.5-1.6 C5.3,5.2,5.5,5,5.7,4.7C5.7,4.7,5.6,4.6,5.6,4.6C5.2,4.3,4.9,4,4.3,3.8L3.4,3.5L4,3C1,3.9,0,6.6,0,9.5C0,13.7,3.9,17,8.6,17 c4.8,0,8.6-3.4,8.6-7.5C17.2,6.5,16.1,3.6,12.9,2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.3,4.9C6,5.1,5.7,5.4,5.5,5.8C5.3,6.1,5.1,6.5,5.1,7.2C6.4,6.5,7.2,7,7.9,6.5c0,0.2,0,0.3,0,0.5 c0,0.4,0.1,0.8,0.3,1.1c0.2,0.4,0.5,0.7,1,1.1C9.7,8.8,9.9,8.4,10,8c0.1-0.4,0.2-0.8,0.2-1.2c0-0.2-0.1-0.5-0.2-0.7 c0.8,0.1,1.4-0.6,2.7-0.4c-0.3-0.6-0.6-0.9-0.9-1.2c-0.3-0.3-0.7-0.4-1.1-0.5c-0.1,0-0.2,0-0.2,0c0.5-0.4,0.8-1,1.8-1.5 C11.9,2.1,11.4,2,11,1.9c-0.4-0.1-0.8,0-1.2,0.1c-0.4,0.1-0.7,0.3-1,0.5C8.7,2.6,8.5,2.7,8.4,2.9c-0.4-1.5-1-2.6-1-2.7L7.1,0.3 c0,0,0.6,1.2,1,2.7C8.1,3,8,3,8,3C7.7,2.8,7.3,2.6,6.9,2.5c-0.4-0.1-0.8-0.1-1.2,0C5.3,2.7,4.9,2.9,4.4,3.3C5.7,3.7,6,4.4,6.6,4.7 C6.5,4.8,6.4,4.8,6.3,4.9z M8.9,4.2C8.9,4.2,8.9,4.2,8.9,4.2C8.9,4.2,8.9,4.2,8.9,4.2C8.9,4.2,8.9,4.2,8.9,4.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTomatoColor);
export default __webpack_public_path__ + "static/media/tomato-color.7d3124803c49c8de782267ad3f5cc36a.svg";
export { ForwardRef as ReactComponent };